import React from 'react';
import loadable from '@loadable/component';

const LoadingSpinner = loadable(() =>
  import('../../../components/loading_spinner/loading_spinner')
);

let ListPageComponent = false;
let ListPageComponentLegacy = false;
let ListPageComponent2025 = false;
let ListPageComponent2024 = false;
let ListPageComponent2023 = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  ListPageComponent = require('./world_changing_ideas_list_page').default;
  // eslint-disable-next-line global-require
  ListPageComponent2025 = require('./world_changing_ideas_list_page_2025')
    .default;
  // eslint-disable-next-line global-require
  ListPageComponent2024 = require('./world_changing_ideas_list_page_2024')
    .default;
  // eslint-disable-next-line global-require
  ListPageComponent2023 = require('./world_changing_ideas_list_page_2023')
    .default;
  // eslint-disable-next-line global-require
  ListPageComponentLegacy = require('./world_changing_ideas_list_page_legacy')
    .default;
}
/**
 * List Lander Page
 */
export function wciListPage(store) {
  const routeConfig = {
    path: '/world-changing-ideas/:page(list)',
    component() {
      if (ListPageComponent) {
        return <ListPageComponent />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: ListPageComponent ? ListPageComponent.loadData(store) : false,
    preloadChunk() {
      return import('./world_changing_ideas_list_page').then(resp => {
        ListPageComponent = resp.default;
        routeConfig.loadData = ListPageComponent.loadData(store);

        return ListPageComponent;
      });
    },
    chunk: 'wciListPage'
  };

  const LazyComponent = loadable(() => routeConfig.preloadChunk(), {
    fallback: (
      <section className="post-page">
        <article className="post__main">
          <LoadingSpinner />
        </article>
      </section>
    )
  });

  return routeConfig;
}

/**
 * List Lander Page old
 */

export function wciListPage2025(store) {
  const routeConfig = {
    path: '/world-changing-ideas/:page(2025)',
    component() {
      if (ListPageComponent2025) {
        return <ListPageComponent2025 />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: ListPageComponent2025
      ? ListPageComponent2025.loadData(store)
      : false,
    preloadChunk() {
      return import('./world_changing_ideas_list_page_2025').then(resp => {
        ListPageComponent2025 = resp.default;
        routeConfig.loadData = ListPageComponent2025.loadData(store);

        return ListPageComponent2025;
      });
    },
    chunk: 'wciListPage'
  };

  const LazyComponent = loadable(() => routeConfig.preloadChunk(), {
    fallback: (
      <section className="post-page">
        <article className="post__main">
          <LoadingSpinner />
        </article>
      </section>
    )
  });

  return routeConfig;
}

/**
 * List Lander Page old
 */

export function wciListPage2024(store) {
  const routeConfig = {
    path: '/world-changing-ideas/:page(2024)',
    component() {
      if (ListPageComponent2024) {
        return <ListPageComponent2024 />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: ListPageComponent2024
      ? ListPageComponent2024.loadData(store)
      : false,
    preloadChunk() {
      return import('./world_changing_ideas_list_page_2024').then(resp => {
        ListPageComponent2024 = resp.default;
        routeConfig.loadData = ListPageComponent2024.loadData(store);

        return ListPageComponent2024;
      });
    },
    chunk: 'wciListPage'
  };

  const LazyComponent = loadable(() => routeConfig.preloadChunk(), {
    fallback: (
      <section className="post-page">
        <article className="post__main">
          <LoadingSpinner />
        </article>
      </section>
    )
  });

  return routeConfig;
}

export function wciListPage2023(store) {
  const routeConfig = {
    path: '/world-changing-ideas/:page(2023)',
    component() {
      if (ListPageComponent2023) {
        return <ListPageComponent2023 />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: ListPageComponent2023
      ? ListPageComponent2023.loadData(store)
      : false,
    preloadChunk() {
      return import('./world_changing_ideas_list_page_2023').then(resp => {
        ListPageComponent2023 = resp.default;
        routeConfig.loadData = ListPageComponent2023.loadData(store);

        return ListPageComponent2023;
      });
    },
    chunk: 'wciListPage'
  };

  const LazyComponent = loadable(() => routeConfig.preloadChunk(), {
    fallback: (
      <section className="post-page">
        <article className="post__main">
          <LoadingSpinner />
        </article>
      </section>
    )
  });

  return routeConfig;
}

export function wciListPageLegacy(store) {
  const routeConfig = {
    path: '/world-changing-ideas/:page(2022)',
    component() {
      if (ListPageComponentLegacy) {
        return <ListPageComponentLegacy />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: ListPageComponentLegacy
      ? ListPageComponentLegacy.loadData(store)
      : false,
    preloadChunk() {
      return import('./world_changing_ideas_list_page_legacy').then(resp => {
        ListPageComponentLegacy = resp.default;
        routeConfig.loadData = ListPageComponentLegacy.loadData(store);

        return ListPageComponentLegacy;
      });
    },
    chunk: 'wciListPage'
  };

  const LazyComponent = loadable(() => routeConfig.preloadChunk(), {
    fallback: (
      <section className="post-page">
        <article className="post__main">
          <LoadingSpinner />
        </article>
      </section>
    )
  });

  return routeConfig;
}
